import ToggleSwitch from "../../../../../shared/ToggleSwitch";

/**
 * Labeled on/off row with optional revealed content and inline error text.
 * Pure presentational — the switch value and content are controlled by the parent.
 *
 * @param {object} props
 * @param {string} props.label - Row label text.
 * @param {boolean} props.checked - Whether the row is toggled on.
 * @param {(next: boolean) => void} props.onToggle - Fires with the new on/off value.
 * @param {string} [props.errorMessage] - Inline error shown under the row when present.
 * @param {import('react').ReactNode} [props.children] - Content revealed while on.
 * @returns {import('react').JSX.Element}
 */
const ToggleRow = ({ label, checked, onToggle, errorMessage, children }) => (
    <div
        className={`site-customization-toggle-row${
            errorMessage ? " site-customization-toggle-row--error" : ""
        }`}
    >
        <div className="site-customization-toggle-row__header">
            <span className="site-customization-toggle-row__label">{label}</span>
            <ToggleSwitch checked={checked} onToggle={onToggle} />
        </div>
        {errorMessage ? (
            <p className="site-customization-toggle-row__error" role="alert">
                {errorMessage}
            </p>
        ) : null}
        {checked && children ? (
            <div className="site-customization-toggle-row__content">{children}</div>
        ) : null}
    </div>
);

export default ToggleRow;
